import React, { useCallback, useRef } from "react";
import { Button, Form } from "react-bootstrap";
import ListClient from "../ListClient";
import { IClientType } from "../../../../../interfaces/api/IClientsType";
import { useGetClientsTypeQuery } from "../../../../../services/api/repositories/ClientTypeRepository";

export default function ClientInput(
    { clientTypeList, handleClientTypeAdd, handleClientTypeUuidAdd, handleClientTypeRemove }:
        { clientTypeList: IClientType[], handleClientTypeAdd: (clientType: IClientType) => void, handleClientTypeUuidAdd: (arg0: string) => void, handleClientTypeRemove: (uuid: string) => void }) {

    const clientsQuery = useGetClientsTypeQuery();

    const clientRef = useRef<HTMLSelectElement>(null);

    const handleAdd = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {

        if (clientRef.current?.value) {
            const selectedUuid = clientRef.current?.value;
            const selectedClient = clientsQuery.data?.client_types.find(clientType => clientType.uuid === selectedUuid);

            if (selectedClient) {
                handleClientTypeAdd(selectedClient);
                handleClientTypeUuidAdd(selectedUuid);
            }
        }
    }, [clientRef, clientsQuery.data?.client_types, handleClientTypeAdd, handleClientTypeUuidAdd]);

    return (
        <Form.Group className="form-group attachs">
            <Form.Label className="form-label" htmlFor="mailing-email-attach-select">Clients cible</Form.Label>
            <p className="form-help">Veuillez sélectionner les clients ciblés par cette configuration d'envoi.</p>
            <ListClient clientTypeList={clientTypeList} handleClientTypeRemove={handleClientTypeRemove} />
            <div className="form-addItem">
                <Form.Label className="form-label" htmlFor="mailing-email-attachments-addAttachment">Ajouter un client cible</Form.Label>
                <Form.Select
                    className="form-select"
                    id="mailing-email-attachments-addAttachment"
                    tabIndex={9}
                    ref={clientRef}
                    defaultValue={"none"}
                >
                    <option value="none" disabled>Sélectionner un client cible</option>
                    {clientsQuery.isLoading && <option>Chargement...</option>}
                    {
                        !clientsQuery.isLoading && clientsQuery.data?.client_types && (
                            <>
                                {clientsQuery.data.client_types.map(clientType => (
                                    <option key={clientType.uuid} value={clientType.uuid}>
                                        {clientType.name}
                                    </option>
                                ))}
                            </>
                        )
                    }
                </Form.Select>
                <Button type="button" className="btn btn-primary btn-sm btn-add" title="Ajouter le Client cible" onClick={handleAdd}>
                    <span className="icon"></span>
                    <span className="text">Ajouter</span>
                </Button>
            </div>
        </Form.Group >
    );
}
